import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { daysUntilBirthday, formatDate } from "../../utils/dateUtils";
import { initialLetter } from "../../utils/idUtils";

export default function FamilyView({
  members, memberViewMode, memberSortOrder,
  user, currentFamily, userProfile,
  lang, darkMode,
  viewProfile, setActiveTab, setCameFromProfilePicker,
  setNicknameValue, setEditingNickname,
  setMembers, deleteManagedMember,
  getDisplayName, makeLongPress,
  showToast, tr,
}) {
 const sortedMembers = [...members].sort(function(a, b) {
  if (memberSortOrder === "name") return (a.name || "").localeCompare(b.name || "");
  if (memberSortOrder === "birthday") {
    const da = daysUntilBirthday(a.birthday);
    const db2 = daysUntilBirthday(b.birthday);
    if (da === null && db2 === null) return 0;
    if (da === null) return 1;
    if (db2 === null) return -1;
    // Si es hoy (0), va primero
    if (da === 0 && db2 !== 0) return -1;
    if (db2 === 0 && da !== 0) return 1;
    return da - db2;
  }
  return 0;
});

  const handleLongPress = function(m) {
    return function() {
      if (m.isManaged) {
        deleteManagedMember(m.id);
      } else if (window.confirm(tr("removeMemberConfirm").replace("{name}", m.name))) {
        getDoc(doc(db, "families", currentFamily.id)).then(function(fSnap) {
          const newIds = (fSnap.data().memberIds || []).filter(function(id) { return id !== m.id; });
          updateDoc(doc(db, "families", currentFamily.id), { memberIds: newIds });
          updateDoc(doc(db, "users", m.id), { families: (m.families || []).filter(function(id) { return id !== currentFamily.id; }) });
          setMembers(function(ms) { return ms.filter(function(x) { return x.id !== m.id; }); });
          showToast(tr("memberRemoved").replace("{name}", m.name));
        });
      }
    };
  };

  const canDelete = function(m) {
    const isAdminCard = user && currentFamily && currentFamily.leaderId === user.uid;
    const canDeleteManaged = user && m.isManaged && m.managedBy === user.uid;
    return (isAdminCard && m.id !== user.uid) || canDeleteManaged;
  };

  const onCardClick = function(m) {
    viewProfile(m);
    setActiveTab("groups");
    setCameFromProfilePicker(true);
  };

  const onNicknameClick = function(e) {
    e.stopPropagation();
    setNicknameValue((userProfile?.groupNicknames || {})[currentFamily?.id] || "");
    setEditingNickname(true);
  };

  // ── LIST MODE ──
  if (memberViewMode === "list") {
  return (
    <div className="familia-grid">
      {sortedMembers.map(function(m) {
        const color = m.color || "#9b59b6";
        const days = daysUntilBirthday(m.birthday);
        const isBirthdayToday = days === 0;
        return (
          <div key={m.id} className="miembro-wrapper">
            <div
              className="miembro-card"
              style={{
                borderLeft: "4px solid " + color,
                background: isBirthdayToday ? (darkMode ? "#2a2200" : "#fff8e6") : "",
                boxShadow: isBirthdayToday ? "0 0 0 2px #d4a853" : "",
              }}
              onClick={function() { onCardClick(m); }}
              {...(canDelete(m) ? makeLongPress(handleLongPress(m)) : {})}
            >
              <div className="miembro-avatar-wrap">
                {currentFamily && currentFamily.leaderId === m.id && <div className="miembro-crown">👑</div>}
                <div className="miembro-avatar" style={{ background: color }}>{initialLetter(m.name)}</div>
                {m.isManaged && user && m.managedBy === user.uid && <div className="miembro-managed-icon">✏️</div>}
              </div>
              <div className="miembro-info">
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <div className="miembro-nombre">{getDisplayName(m)}</div>
                  {isBirthdayToday && <span style={{ fontSize: 16 }}>🎂</span>}
                  {user && m.id === user.uid && (
                    <span style={{ fontSize: 10, color: "#d4a853", cursor: "pointer" }} onClick={onNicknameClick}>✏️</span>
                  )}
                </div>
                {isBirthdayToday && (
                  <div style={{ fontSize: 12, fontWeight: 600, color: "#d4a853", marginBottom: 2 }}>
                    {lang === "es" ? "🎉 ¡Hoy es su cumpleaños!" : lang === "fi" ? "🎉 Tänään on syntymäpäivä!" : "🎉 Today is their birthday!"}
                  </div>
                )}
                {m.birthday && (
                  <div className="miembro-cumple">
                    <span>🎂 {formatDate(m.birthday)}</span>
                    {!isBirthdayToday && days !== null && days <= 30 && (
                      <span className="cumple-days">🎉 {days} {lang === "es" ? "días" : lang === "fi" ? "pv" : "days"}!</span>
                    )}
                  </div>
                )}
                <div className="miembro-regalos" style={{ color }}>{m.gifts.length} {tr("gifts")}</div>
              </div>
              <span style={{ color: "#ccc", fontSize: 16, flexShrink: 0 }}>›</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ── GRID MODE ──
  if (memberViewMode === "grid") {
  return (
    <div className="familia-grid-old">
      {sortedMembers.map(function(m) {
        const color = m.color || "#9b59b6";
        const days = daysUntilBirthday(m.birthday);
        const isBirthdayToday = days === 0;
        return (
          <div key={m.id} className="miembro-wrapper">
            <div
              className="miembro-card grid-mode"
              style={{
                borderLeft: "none",
                borderTop: "4px solid " + color,
                background: isBirthdayToday ? (darkMode ? "#2a2200" : "#fff8e6") : "",
                boxShadow: isBirthdayToday ? "0 0 0 2px #d4a853" : "",
              }}
              onClick={function() { onCardClick(m); }}
              {...(canDelete(m) ? makeLongPress(handleLongPress(m)) : {})}
            >
              <div className="miembro-avatar-wrap">
                {currentFamily && currentFamily.leaderId === m.id && <div className="miembro-crown">👑</div>}
                <div className="miembro-avatar" style={{ background: color }}>{initialLetter(m.name)}</div>
                {m.isManaged && user && m.managedBy === user.uid && <div className="miembro-managed-icon">✏️</div>}
              </div>
              <div className="miembro-info">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                  <div className="miembro-nombre">{getDisplayName(m)}</div>
                  {isBirthdayToday && <span style={{ fontSize: 14 }}></span>}
                  {user && m.id === user.uid && (
                    <span style={{ fontSize: 10, color: "#d4a853", cursor: "pointer" }} onClick={onNicknameClick}>✏️</span>
                  )}
                </div>
                {isBirthdayToday && (
                  <div style={{ fontSize: 11, fontWeight: 600, color: "#d4a853", textAlign: "center" }}>
                    {lang === "es" ? "🎉 ¡Hoy es su cumpleaños!" : lang === "fi" ? "🎉 Tänään on syntymäpäivä!" : "🎉 Today is their birthday!"}
                  </div>
                )}
                {m.birthday && (
                  <div className="miembro-cumple">
                    <span> {formatDate(m.birthday)}</span>
                    {!isBirthdayToday && days !== null && days <= 30 && (
                      <span className="cumple-days">🎉 {days} {lang === "es" ? "días" : lang === "fi" ? "pv" : "days"}!</span>
                    )}
                  </div>
                )}
                <div className="miembro-regalos" style={{ color }}>{m.gifts.length} {tr("gifts")}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

  // ── COMPACT MODE ──
  return (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginTop: 4 }}>
    {sortedMembers.map(function(m) {
      const color = m.color || "#9b59b6";
      const dBirthday = daysUntilBirthday(m.birthday);
      const isBirthdayToday = dBirthday === 0;
      const soonBirthday = dBirthday !== null && dBirthday <= 30;
      return (
        <div
          key={m.id}
          style={{
            background: isBirthdayToday ? (darkMode ? "#2a2200" : "#fff8e6") : (darkMode ? "#1e1e1e" : "#fff"),
            border: "1px solid " + (isBirthdayToday ? "#d4a853" : (darkMode ? "#2e2e2e" : "#e8e2d9")),
            borderRadius: 14, padding: "12px 8px 10px",
            display: "flex", flexDirection: "column", alignItems: "center", gap: 6,
            cursor: "pointer", position: "relative", borderTop: "3px solid " + color,
            boxShadow: isBirthdayToday ? "0 0 0 2px #d4a853" : "",
          }}
          onClick={function() { onCardClick(m); }}
          {...(canDelete(m) ? makeLongPress(handleLongPress(m)) : {})}
        >
          {currentFamily && currentFamily.leaderId === m.id && (
            <div style={{ position: "absolute", top: 6, right: 6, fontSize: 11 }}>👑</div>
          )}
          {soonBirthday && (
            <div style={{ position: "absolute", top: 6, left: 6, fontSize: 11 }}></div>
          )}
          <div style={{ width: 44, height: 44, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color: "#fff", fontFamily: "Playfair Display, serif", fontWeight: 700, flexShrink: 0 }}>
            {initialLetter(m.name)}
          </div>
          <div style={{ fontSize: 12, fontWeight: 400, color: darkMode ? "#e8e2d9" : "#1a1a1a", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%", paddingLeft: 4, paddingRight: 4 }}>
            {getDisplayName(m)}
            {user && m.id === user.uid && (
              <span style={{ fontSize: 9, color: "#d4a853", marginLeft: 3, cursor: "pointer" }} onClick={onNicknameClick}>✏️</span>
            )}
          </div>
          {soonBirthday && (
            <div style={{ fontSize: 10, fontWeight: 600, color: isBirthdayToday ? "#d4a853" : "#e67e22" }}>
              {isBirthdayToday
                ? (lang === "es" ? "🎉 ¡Hoy!" : lang === "fi" ? "🎉 Tänään!" : "🎉 Today!")
                : dBirthday + (lang === "es" ? " días" : lang === "fi" ? " pv" : "d")}
            </div>
          )}
        </div>
      );
    })}
  </div>
);
}
